import { render, staticRenderFns } from "./insurance_patients.vue?vue&type=template&id=1fc154b7&"
import script from "./insurance_patients.vue?vue&type=script&lang=js&"
export * from "./insurance_patients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports